'use client'

// Narrow, per-concern selector hook for the header category dropdown (#118
// server-chrome, Step 3). Wraps ONLY the selected-category state field and its
// mutator — the open/close driver for a category's <NavDropdown>. Mirrors the
// Step-1 read-seam discipline; no facade over the store.
//
// `selectedCategory` is the currently-open category title (or null); `select`
// sets it. The island derives per-category `isOpen` from `selectedCategory ===
// title`. The selected-category field moved off Overmind to the Zustand ui store
// (Phase C2 part 1); `select` mirrors the former actions.updateSelectedHeaderCategory.

import { useUiStore } from '../../store/uiStore'

export function useHeaderDropdown() {
  const selectedHeaderCategory = useUiStore((s) => s.selectedHeaderCategory)
  const setSelectedHeaderCategory = useUiStore((s) => s.setSelectedHeaderCategory)
  return {
    selectedCategory: selectedHeaderCategory,
    select: (category) => setSelectedHeaderCategory(category),
  }
}
